export const formatDateBrToUsIso = (date) => {
    if (!date || date.length < 10) return '00-00-0000';

    return date.substr(0, 10).split('/').reverse().join('-');
};
